import React from 'react'
import {Link} from 'react-router-dom';

const Error = () => {
    return (
        <div className="container">
            <h1>Oops! Page Not Found - 404 Page</h1>
            <Link to='/' className="btn-primary">
                Return Home
            </Link>
        </div>
    )
}

export default Error
